import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import InvoicePaymentsTable from "@/components/invoices/payments/payments-table";

const paymentsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  paymentMethod: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/invoices/payments/",
)({
  validateSearch: paymentsSearchSchema,
  component: InvoicesPaymentsPage,
});

function InvoicesPaymentsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "invoices_payments", actions: ["read"] }]}>
      
    <div className="space-y-4">
      <InvoicePaymentsTable
        currentPage={searchParams.page}
        basePath="/invoices/payments"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
